import type { ExperimentId } from "@globals";
import { useAgentChat } from "@lib/agent/useAgentChat";
import type { ReactNode } from "react";
import { createContext, useContext } from "react";

type AgentChatContextValue = ReturnType<typeof useAgentChat> & {
  experimentId: ExperimentId;
  teamId: string | null;
};

const AgentChatContext = createContext<AgentChatContextValue | null>(null);

export function AgentChatProvider({
  experimentId,
  teamId,
  children
}: {
  experimentId: ExperimentId;
  teamId: string | null;
  children: ReactNode;
}) {
  const chat = useAgentChat(experimentId, teamId);
  const value: AgentChatContextValue = { ...chat, experimentId, teamId };
  return <AgentChatContext.Provider value={value}>{children}</AgentChatContext.Provider>;
}

export function useAgentChatContext(): AgentChatContextValue {
  const ctx = useContext(AgentChatContext);
  if (!ctx) {
    throw new Error("useAgentChatContext must be used within AgentChatProvider");
  }
  return ctx;
}
